import { createStore } from 'vuex';

import globalSettings from './globalSettings';
import globalSearch from './globalSearch';
import sampleFormProducts from './sampleFormProducts';
import profilePageData from './profilePageData';
import contentSearch from './contentSearch';
import search from './search';
import enrollmentForm from './enrollmentForm';
import enrollments from './enrollments';
import enrollmentFacility from './enrollmentFacility';
import visitor from './visitor';
import locale from './localeStore';
import globalCheckout from './globalCheckout';
import accountPage from './accountPage';
import basket from './basket';
import addToBasket from './addToBasket';
import addToMyProducts from './addToMyProducts';
import gallery from './gallery';
import myProducts from './myProducts';
import galleryImagesModal from "./galleryImagesModal";
import consumerUserPreferences from './consumerUserPreferences';
import contentLibrary from './contentLibrary';
import contentGate from './contentGate';
import heylo from './heylo';
import globalAssets from './globalAssets';
import orderHistory from './orderHistory';
import addressSearch from './addressSearch';
import microSite from './microSite';
import fitTool from './fitTool';
import hcpPortal from './hcpPortal';

export const generateStore = () => {
	return createStore({
		modules: {
			globalSettings,
			search,
			globalSearch,
			sampleFormProducts,
			profilePageData,
			contentSearch,
			enrollmentForm,
			enrollments,
			enrollmentFacility: enrollmentFacility,
			locale,
			visitor,
			galleryImagesModal,
			globalCheckout,
			basket,
			addToBasket,
			addToMyProducts,
			accountPage,
			gallery,
			myProducts,
			consumerUserPreferences,
			contentLibrary,
			contentGate,
			heylo,
			globalAssets,
			orderHistory,
			addressSearch,
			microSite,
			fitTool,
			hcpPortal
		}
	})
}

export const store = generateStore();

export default store;
